
import PropertyList from './PropertyList.js';
import path from 'path-browserify';

/**
 */
class VersionVM
{
	constructor(FS, resource, href)
	{
		this.FS = FS;
		/**
		 * Resource path (not including any host details)
		 * @type {Observable<string>}
		 */
		this.href = ko_helper.safe_observable(href);

		/**
		 * Version label
		 */
		this.version_label = ko.observable(null);

		/**
		 * Version number
		 */
		this.version = ko.observable(null);

		/**
		 * All Version labels
		 */
		this.labels = ko.observableArray([]);

		/**
		 * Version-controlled resource
		 */
		this.resource = ko_helper.safe_observable(resource);

		/**
		 * Properties
		 */
		this.property_list = new PropertyList();
		
		/**
		 * All resource types
		 * @type {Array<Object {name, nsuri}>}
		 */
		this.resourcetypes = ko.observableArray([]);

		/**
		 * Version status, CI, CO or NA
		 */
		this.status = ko.observable('NA');

	}

	get(nsuri, name) { return this.property_list.get(nsuri, name); }
	set(nsuri, name, value) { return this.property_list.set(nsuri, name, value); }

	set_properties(properties)
	{
		this.property_list.set_properties(properties);
		const resourcetype = this.property_list.get('DAV:', 'resourcetype');
		if (resourcetype)
		{
			if (Array.isArray(resourcetype))
			{
				this.resourcetypes(resourcetype);
			}
			else
			{
				this.resourcetypes([{nsuri: 'DAV:', name: resourcetype}]);
			}
		}
	}

	async save_property(nsuri, name, value)
	{
		return this.save_properties([{nsuri: nsuri, name: name, value: value}]);
	}
	
	async save_properties(properties, remove_properties=[])
	{
		let options = {};
		if (this.resource().locktoken())
			options['locktoken'] = this.resource().locktoken();
		return this.FS.update(this.resource().href(), properties, remove_properties, options);
	}

	has_type(nsuri, name) { return this.resourcetypes().find((x) => x.nsuri == nsuri && x.name == name); }

	/**
	 * Populate properties from server
	 */
	async fetch(properties=[])
	{
		if (!this.href())
			return;
		let list_result = await this.FS.list(this.href(), 1, properties, this.version_label());
		if (!list_result)
			throw new Error(`Error while listing "${this.href()}"`);

		if (typeof(list_result) === 'object' && list_result.error)
		{
			this.error = list_result.error;
			throw {code: this.error.code, message: `Error while listing "${this.href()}": ${this.error.message}`};
		}

		let result = list_result.find((r) => path.relative(r.full_path, this.href()) == '');
		if (!result)
			throw new Error('Resource not found in result list');
		this.set_properties(result.properties);

	}

	async report(report_nsuri, report_name, options)
	{
		return this.FS.report(this.href(), report_nsuri, report_name, options);
	}

	async checkout()
	{
		return this.FS.checkout(this.href());
	}

	async checkin()
	{
		return this.FS.checkin(this.href());
	}

	/**
	 * Fetch content as text
	 */
	async fetch_content()
	{
		let response = await Grape.fetches.fetch(this.href());
		return await response.text();
	}

	/**
	 * Fetch data as ArrayBuffer
	 */
	async fetch_array()
	{
		let response = await Grape.fetches.fetch(this.href());
		return await response.arrayBuffer();
	}

}

export default VersionVM;

